import React from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import Select from 'react-select';
import { selectStyle } from './SelectStyle';

const SearchableSelect = ({
  isMobileView,
  ref,
  disabled,
  value,
  handleInputChange,
  options,
  onChange,
  placeholder,
  autoFocus = false,
}) => {
  return (
    <Select
      components={{
        DropdownIndicator: () => (
          <div>
            <MdKeyboardArrowDown />
          </div>
        ),
        IndicatorSeparator: () => null,
      }}
      inputRef={ref}
      autoFocus={autoFocus}
      isDisabled={disabled}
      value={value}
      onChange={(selectedValue) => {
        onChange(selectedValue.value);
      }}
      className="text-xs md:text-sm"
      placeholder={placeholder}
      onInputChange={(newValue) => handleInputChange(newValue)}
      options={options ? options : []}
      styles={selectStyle(isMobileView)}
    />
  );
};

export default SearchableSelect;
